import React from 'react'
import "./Separator.css"
const Separator = () => {
  return (
    <div className='separator-container'>
        <div className='separator'>
            <h1><strong>NO MALGASTES MÁS TIEMPO ARGUMENTANDO ACERCA DE LO QUE DEBE SER UN BUEN HOMBRE. TRATA DE SER UNO.</strong></h1>
        </div>
    </div>
  )
}

export default Separator